/* eslint-disable */
import React, { useEffect, useContext, useState, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

//import translation function for language translation
import { useTranslation } from "react-i18next";

// Import Editor here (both required).
// import { Editor } from "@tinymce/tinymce-react";
import JoditEditor from "jodit-react";

/*import url and gateway methods */
import {
  postData,
  putData,
  uploadMultipleFile,
  getData,
  uploadSingleFile,
} from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import context
// import { GlobalProvider } from "context/GlobalContext";
// import downloadFileHandler from "helper/DownloadFile";

import TaskStatusOptions from "data/Prod/TaskStatus.json";
import { calculateEndTime, getEndTime } from "helper/TimeCalculation";
import { reactSelectStyle } from "Config/Config";
import JoditEditorField from "components/Common/JoditEditorField/JoditEditorField";
// import TaskPriority from "data/Prod/TaskPriority.json";
// import { assetImages } from "constants";
// import { joditEditorConfig } from "Config/Config";

const SaveLogPopup = ({
  selectedLogId,
  onPopUpClose = () => {},
  afterLogSave = () => {},
}) => {
  const { t } = useTranslation(); // translation

  const todayValue = new Date().toISOString().split("T")[0];

  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [taskId, setTaskId] = useState(null);
  const [taskStatusValue, settaskStatusValue] = useState(null);
  const [taskStatusData, settaskStatusData] = useState("");
  const [taskPercent, settaskPercent] = useState("");
  const [logHours, setlogHours] = useState("");
  const [logStartDate, setlogStartDate] = useState(todayValue);
  const [logEndDate, setlogEndDate] = useState(todayValue);
  const [logStartTime, setlogStartTime] = useState("");
  const [logEndTime, setlogEndTime] = useState("");
  const [logDetails, setlogDetails] = useState("");
  const [logOwner, setLogOwnerId] = useState(null);
  const [logAdding, setlogAdding] = useState(false);

  //* hook for validation */
  const [validation, setValidation] = useState({
    hoursWarning: false,
    detailsWarning: false,
    statusWarning: false,
  });

  //* function to validate form */
  const validationHandler = () => {
    let isValid = true;

    if (logHours === "" || logHours == 0) {
      setValidation((prevState) => ({ ...prevState, hoursWarning: true }));
      isValid = false;
    }

    if (taskStatusData === null) {
      setValidation((prevState) => ({ ...prevState, userWarning: true }));
      isValid = false;
    }

    if (logDetails === "") {
      setValidation((prevState) => ({
        ...prevState,
        detailsWarning: true,
      }));
      isValid = false;
    }

    return isValid;
  };

  //** function for get log details */
  const getLogDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_LOG_DETAILS +
        `/${selectedLogId}?token=${token}`;

      console.log("log details url", requestUrl);

      const response = await getData(requestUrl);

      console.log("log details response", response);

      if (response.status && response.data) {
        setLogOwnerId(response.data.logowner?._id ?? null);
        setTaskId(response.data.projecttask?._id ?? null);
        setlogHours(response.data.hours);
        setlogStartDate(response.data.startdate);
        setlogEndDate(response.data.enddate);
        setlogStartTime(response.data.starttime);
        setlogEndTime(response.data.endtime);
        settaskPercent(response.data.taskpercent);
        setlogDetails(response.data.description);
        TaskStatusOptions.map((statusData) => {
          if (statusData.value == response.data.completedpercent) {
            statusSelectionHandler(statusData);
          }
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //* select status */
  const statusSelectionHandler = (val) => {
    settaskStatusValue(val);

    if (
      val.value === "0" ||
      val.value === "1" ||
      val.value === "2" ||
      val.value === "3"
    ) {
      settaskStatusData(val.value);
    }
  };

  //** Funciton for save log */
  const saveLogHandler = async () => {
    if (validationHandler()) {
      try {
        setlogAdding(true);

        let logData = {
          projecttask: taskId,
          completedpercent: taskStatusData,
          description: logDetails,
          startdate: logStartDate,
          enddate: logEndDate,
          starttime: logStartTime,
          endtime: logEndTime,
          hours: logHours,
          taskpercent: taskPercent,
        };

        let response = {};

        let requestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_TASK_LOG +
          `/${selectedLogId}?token=${token}`;

        response = await putData(requestUrl, logData);

        setlogAdding(false);

        console.log(response);

        if (response.status) {
          // close the offcanvas of filter
          let offCanvasPopup = document.querySelector("#saveLog");
          let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
          offCanvas.hide();
          resetHandler();
          afterLogSave(response.data);
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  const resetHandler = () => {
    setTaskId(null);
    settaskStatusValue(null);
    settaskStatusData("");
    settaskPercent("");
    setlogHours("");
    setlogStartDate(todayValue);
    setlogEndDate(todayValue);
    setlogDetails("");
  };

  useEffect(() => {
    if (selectedLogId) {
      getLogDetails();
    }
  }, [selectedLogId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveLog"
      aria-labelledby="saveLog"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              description
            </span>{" "}
            {/* Using 'description' icon as a placeholder */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {t("Log Details")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Manage existing log details")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => {
            resetHandler();
            onPopUpClose();
          }}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        {/* save log form */}
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="row">
                  <div className="col-lg-3 mb-3 mb-lg-0">
                    <label
                      htmlFor=""
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Time (Hours)")}
                    </label>
                    <input
                      type="number"
                      className={`form-control fs-sm shadow-none ${
                        validation.hoursWarning
                          ? "is-invalid"
                          : "border border-gray-300"
                      }`}
                      placeholder={t("Enter hours spent on the task")}
                      value={logHours}
                      onChange={(e) => {
                        setlogHours(e.target.value);
                        if (logStartTime !== "") {
                          const endTime = calculateEndTime(
                            e.target.value,
                            logStartTime
                          );
                          setlogEndTime(endTime);
                        }
                        setValidation((prevState) => ({
                          ...prevState,
                          hoursWarning: false,
                        }));
                      }}
                    />
                    {validation.hoursWarning && (
                      <div className="invalid-feedback">
                        {t("Hours cannot be empty or zero.")}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-3">
                    <label
                      htmlFor=""
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Log Date")}
                    </label>
                    <div className="field-container d-flex flex-column flex-lg-row gap-lg-0 align-items-lg-center bg-lg-white border-lg border-gray-300 rounded-10">
                      <input
                        type="date"
                        id="startdate"
                        className="form-control bg-white border-gray-300 fs-sm shadow-none me-3"
                        placeholder={t("Select log date")}
                        value={logStartDate}
                        onChange={(e) => {
                          setlogStartDate(e.target.value);
                          setlogEndDate(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 mb-3 mb-lg-0">
                    <label
                      htmlFor=""
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Complete %")}
                    </label>
                    <input
                      type="number"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t("Enter completion percentage (0-100)")}
                      value={taskPercent}
                      onChange={(e) => {
                        if (e.target.value >= 0 && e.target.value <= 100) {
                          settaskPercent(e.target.value);
                        }
                      }}
                    />
                  </div>
                  <div className="col-lg-3 mb-3 mb-lg-0">
                    <label
                      htmlFor=""
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Task Status")}
                    </label>
                    <Select
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      placeholder={t("Select task status")}
                      options={TaskStatusOptions}
                      value={taskStatusValue}
                      onChange={(val) => {
                        statusSelectionHandler(val);
                        if (validation.statusWarning) {
                          setValidation((prev) => ({
                            ...prev,
                            statusWarning: false,
                          }));
                        }
                      }}
                    />
                    {validation.statusWarning && (
                      <div className="invalid-feedback d-block">
                        {t("Please select a task status!")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
                <JoditEditorField
                  label={t("Details")}
                  value={logDetails}
                  onChange={(newContent) => setlogDetails(newContent)}
                  labelClassName="d-block fs-sm fw-semibold mb-2 text-dark"
                  editorHeight={250}
                />

                {validation.detailsWarning && (
                  <div className="error-message mt-2">
                    <p className="d-flex align-items-center gap-1 text-danger">
                      <span className="material-symbols-outlined">warning</span>
                      <span>{t("Please enter details!")}</span>
                    </p>
                  </div>
                )}
              </div>
            </div>

            {userInfo.role.slug === "ADMIN" ||
            userInfo.role.slug === "SUPER_ADMIN" ||
            (logOwner && logOwner.toString() === userInfo._id.toString()) ? (
              <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  onClick={saveLogHandler}
                  disabled={logAdding ? true : false}
                  style={{
                    cursor: logAdding ? "not-allowed" : "pointer",
                  }}
                >
                  {logAdding ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {t("Saving...")}
                    </>
                  ) : (
                    <>
                      <span className="material-symbols-outlined me-1">
                        save
                      </span>{" "}
                      {t("Save Log")}
                    </>
                  )}
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveLogPopup;
